import { Action, createReducer, on } from '@ngrx/store';
import { ContactQueries } from './contact-queries.model';
import {
  getContactQueries,
  getContactQueriesFailure,
  getContactQueriesSuccess,
} from './contact-queries.action';

export interface ContactQueriesState {
  list: ContactQueries[];
  detail: ContactQueries | null;
  loading: boolean;
  error: any;
  pageNumber: number | null;
  pageSize: number | null;
  totalPages: number | null;
  totalRecords: number | null;
}

export const initialState: ContactQueriesState = {
  list: [],
  detail: null,
  loading: false,
  error: null,
  pageNumber: null,
  pageSize: null,
  totalPages: null,
  totalRecords: null,
};

export const ContactQueriesReducer = createReducer(
  initialState,
  // Add your case reducers here
  on(getContactQueries, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(getContactQueriesSuccess, (state, { data }) => ({
    ...state,
    list: data.result as ContactQueries[],
    pageNumber: data.pageNumber,
    pageSize: data.pageSize,
    totalPages: data.totalPages,
    totalRecords: data.totalRecords,
    loading: false,
  })),

  on(getContactQueriesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
  }))
);

// Selector
export function reducer(
  state: ContactQueriesState | undefined,
  action: Action
) {
  return ContactQueriesReducer(state, action);
}
